import { render, staticRenderFns } from "./facturacion-autorizaciones.vue?vue&type=template&id=512c8b30&scoped=true"
import script from "./facturacion-autorizaciones.vue?vue&type=script&lang=js"
export * from "./facturacion-autorizaciones.vue?vue&type=script&lang=js"
import style0 from "./facturacion-autorizaciones.vue?vue&type=style&index=0&id=512c8b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c8b30",
  null
  
)

export default component.exports